module.exports = __webpack_public_path__ + "static/media/reading_light.4323acb7.svg";